function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 199.8",
    style: {
      enableBackground: "new 0 0 200 199.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M11.9,197.6c-5.4,0-9.7-4.4-9.7-9.7v-40.8c0-5.4,4.4-9.7,9.7-9.7h176.4c5.4,0,9.7,4.4,9.7,9.7v40.8 c0,5.4-4.4,9.7-9.7,9.7H11.9z M15.8,149c-1.1,0-2,0.9-2,2v33c0,1.1,0.9,2,2,2h168.6c1.1,0,2-0.9,2-2v-33c0-1.1-0.9-2-2-2H15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M32.8,148.8c-5.4,0-9.7-4.4-9.7-9.7V11.9c0-5.4,4.4-9.7,9.7-9.7h101.5c5.4,0,9.7,4.4,9.7,9.7v127.2 c0,5.4-4.4,9.7-9.7,9.7L32.8,148.8L32.8,148.8z M36.7,13.8c-1.1,0-2,0.9-2,2v119.4c0,1.1,0.9,2,2,2h93.7c1.1,0,2-0.9,2-2V15.8 c0-1.1-0.9-2-2-2H36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M93.9,173.8c-3.2,0-5.8-2.6-5.8-5.8s2.6-5.8,5.8-5.8h12.5c3.2,0,5.8,2.6,5.8,5.8s-2.6,5.8-5.8,5.8 H93.9z M142,148.8c-5.4,0-9.7-4.4-9.7-9.7V34.7c0-5.4,4.4-9.7,9.7-9.7h20.3c5.4,0,9.7,4.4,9.7,9.7v104.4c0,5.4-4.4,9.7-9.7,9.7H142z  M146,36.6c-1.1,0-2,0.9-2,2v96.6c0,1.1,0.9,2,2,2h12.5c1.1,0,2-0.9,2-2V38.6c0-1.1-0.9-2-2-2H146z M56.2,122.7 c-3.2,0-5.8-2.6-5.8-5.8s2.6-5.8,5.8-5.8h39.4c3.2,0,5.8,2.6,5.8,5.8s-2.6,5.8-5.8,5.8H56.2z M56.2,95c-3.2,0-5.8-2.6-5.8-5.8 s2.6-5.8,5.8-5.8h54c3.2,0,5.8,2.6,5.8,5.8s-2.6,5.8-5.8,5.8H56.2z M56.2,67.3c-3.2,0-5.8-2.6-5.8-5.8s2.6-5.8,5.8-5.8h54.2 c3.2,0,5.8,2.6,5.8,5.8s-2.6,5.8-5.8,5.8H56.2z M56.2,39.6c-3.2,0-5.8-2.6-5.8-5.8S53,28,56.2,28h17.4c3.2,0,5.8,2.6,5.8,5.8 s-2.6,5.8-5.8,5.8H56.2z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.33e432adbee3d89789072ea1eb3526da.svg";
export { ForwardRef as ReactComponent };